<template>
  <div class="ganPin margin-l-20">
    <div class="ganPin-header margin-r-20">
      <el-date-picker class="margin-l-20" v-model="endTime" type="month" placeholder="选择月" :clearable="false"
                      format="yyyy-MM"
                      value-format="yyyy-MM" :picker-options="pickerOptions" @change="getAll"></el-date-picker>
    </div>
    <el-card class="margin-b-20 text-left margin-r-20 area-total">
      <el-row class="margin-b-40" :gutter="20">
        <el-col :span="8">
          <div class="index-bg" style="background-color: #0AB1DE">
            <div style="float: left;margin-left: 30px">
              <div class="area-index-num">{{total.ljMoney}}</div>
              <div class="index-span-p">累计网络零售额（万元）</div>
<!--              <div class="index-span-yoy"> 同比{{total.ljMoneyYoy}}%</div>-->
            </div>
            <div style="float: right">
              <div class="index-span-box">
                <img src="../../assets/ganpinIndex-ljmoney.png" class=" margin-t-20 margin-r-40"/>
              </div>
            </div>

          </div>
        </el-col>
        <el-col :span="8">
          <div class="index-bg" style="background-color: #EC897D">
            <div style="float: left;margin-left: 30px">
              <div class="area-index-num">{{total.ljSales}}</div>
              <div class="index-span-p">累计网络零售量（万件）</div>
<!--              <div class="index-span-yoy"> 同比{{total.ljSalesYoy}}%</div>-->
            </div>
            <div style="float: right">
              <div class="index-span-box">
                <img src="../../assets/ganpinIndex-ljsales.png" class=" margin-t-20 margin-r-40"/>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="index-bg" style="background-color: #8A9AF4">
            <div style="float: left;margin-left: 30px">
              <div class="area-index-num ">{{total.money}}</div>
              <div class="index-span-p">当期网络零售额（万元）</div>
<!--              <div class="index-span-yoy"> 同比{{total.moneyYoy}}%</div>-->
            </div>
            <div style="float: right">
              <div class="index-span-box">
                <img src="../../assets/ganpinIndex-money.png" class=" margin-t-20 margin-r-40"/>
              </div>
            </div>
          </div>
        </el-col>
      </el-row >
      <el-row class="margin-t-10" :gutter="20">
        <el-col :span="8">
          <div class="index-bg" style="background-color:#84D0AF">
            <div style="float: left;margin-left: 30px">
              <div class="area-index-num">{{total.prodNum}}</div>
              <div class="index-span-p">监测赣品数（个）</div>
            </div>
            <div style="float: right">
              <div class="index-span-box">
                <img src="../../assets/ganpinIndex-ganpinNum.png" class=" margin-t-20 margin-r-40"/>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="index-bg" style="background-color:#D8C477">
            <div style="float: left;margin-left: 30px">
              <div class="area-index-num">{{total.companyNum}}</div>
              <div class="index-span-p">电商企业数（家）</div>
            </div>
            <div style="float: right">
              <div class="index-span-box">
                <img src="../../assets/ganpinIndex-companyNum.png" class=" margin-t-20 margin-r-40"/>
              </div>
            </div>
          </div>
        </el-col>

        <el-col :span="8">
          <div class="index-bg" style="background-color:#C68DD4">
            <div style="float: left;margin-left: 30px">
              <div class="area-index-num">{{total.shopNum}}</div>
              <div class="index-span-p">电商店铺数（家）</div>
            </div>
            <div style="float: right">
              <div class="index-span-box">
                <img src="../../assets/ganpinIndex-shopNum.png" class=" margin-t-20 margin-r-40"/>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <el-row>
      <el-col :span="16" class="padding-r-20">
        <el-card class="margin-b-20">
          <chart ref="chart1" :options="moneyOptions" autoresize class="width-z100"></chart>
        </el-card>

      </el-col>
      <el-col :span="8" class="padding-r-20">
        <el-card>
          <chart ref="chart1" :options="categoryOptions" autoresize class="width-z100"
                 style="height: 400px;margin-left: 18px"></chart>
        </el-card>
      </el-col>

    </el-row>
    <el-row class="margin-b-20">
      <el-col :span="6" class="padding-r-20">
        <el-card class="margin-b-20">
          <chart ref="chart1" :options="platformOptions" autoresize class="width-z100" style="height: 510px"></chart>
        </el-card>

      </el-col>
      <el-col :span="18" class="padding-r-20">
        <el-card>
          <el-row>
            <el-col :span="14">
              <chart ref="chart1" :options="orgOptions" autoresize class="width-z100"
                     style="height: 500px;margin-left: 18px"></chart>

            </el-col>
            <el-col :span="2">
              <img src="../../assets/ganPin-map.jpg" height="157" width="95"
                   style="margin-top: 350px;margin-left: -100px"/>
            </el-col>
            <el-col :span="8">
              <el-row style="margin-top: 50px">
                <el-col :span="12" v-for="map in mapList" :key="map.id" class="font-12 text-666" style="margin-bottom: 5px">
                  {{map.province}}：{{map.money}}元
                </el-col>
              </el-row>
              <!--              <span v-for="map in mapList"></span>-->
            </el-col>
          </el-row>

        </el-card>
      </el-col>

    </el-row>
    <div class="margin-b-20">
      <el-row>
        <el-col :span="8" class="padding-r-20">
          <el-card>
            <div slot="header" class="index-header text-left">
              <span class="index-header-title">九江赣品企业榜</span>
            </div>
            <el-table :data="companyTable" width="480px" height="556px" stripe class="border-DEDEDE"
                      :default-sort="{prop: 'money', order: 'descending'}">
              <el-table-column type="index" label="排名" width="80" align="center"></el-table-column>
              <el-table-column prop="names" label="企业名称"></el-table-column>
              <el-table-column prop="money" label="零售额（元）" width="140" align="center"></el-table-column>
            </el-table>
          </el-card>
        </el-col>
        <el-col :span="8" class="padding-r-20">
          <el-card>
            <div slot="header" class="index-header text-left">
              <span class="index-header-title">九江赣品店铺榜</span>
            </div>
            <el-table :data="goodsShopTable" width="480px" height="556px" stripe class="border-DEDEDE"
                      :default-sort="{prop: 'money', order: 'descending'}">
              <el-table-column type="index" label="排名" width="80" align="center"></el-table-column>
              <el-table-column prop="names" label="店铺名称">
                <template slot-scope="scope">
                  <a :href="scope.row.url"
                     target="_blank"
                     class="buttonText  text-666">{{scope.row.names}}</a>
                </template>
              </el-table-column>
              <el-table-column prop="money" label="零售额（元）" width="150" align="center"></el-table-column>
            </el-table>
          </el-card>
        </el-col>
        <el-col :span="8" class="padding-r-20">
          <el-card>
            <div slot="header" class="index-header text-left">
              <span class="index-header-title">九江赣品单品榜</span>
            </div>
            <el-table :data="goodsListTable" width="480px" height="556px" stripe class="border-DEDEDE"
                      :default-sort="{prop: 'money', order: 'descending'}">
              <el-table-column type="index" label="排名" width="100" align="center"></el-table-column>
              <el-table-column prop="names" label="名称" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <a :href="scope.row.goodsUrl"
                     target="_blank"
                     class="buttonText text-666">{{scope.row.names}}</a>
                </template>
              </el-table-column>
              <el-table-column prop="money" label="零售额（元）" width="150" align="center"></el-table-column>
            </el-table>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <p class="margin-l-30 margin-r-20 font-14 text-8A8A8A">注：<BR/>
      1.特色产品是指九江市当地较为知名且具有地方特色的产品<br/>
      2.特色产品网络零售额是指全国范围内销售九江市特色产品的网络零售额</p>
  </div>

</template>

<script>
  export default {
    name: 'ganPin',
    // 子组件接收参数的核心位置：
    props: ['parent_value'],//截止查询时间
    data () {
      return {
        endTime: '', //选择月份
        orgOptions: {},//地图图表
        total: {},//首页店铺企业等监测宏观数据
        categoryOptions: {},//赣品排行
        platformOptions: {},//交易平台占比图

        companyTable: [],//赣品热销企业榜
        goodsShopTable: [],//赣品热销店铺排行
        goodsListTable: [],//赣品热销单品排行
        moneyOptions: {},//当期网络零售额走势
        categoryTable: [],//特色赣品网络零售排行
        platformComOptions: {},
        mapList: [],
        pickerOptions: {
          disabledDate: (time) => {
            // console.log(time.getMonth());
            let nowDate = new Date()
            let day = nowDate.getDate()
            nowDate.setDate(1);
            if (day > 14) {
              if(nowDate.getMonth()==0){
                nowDate.setMonth(11);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else{
                nowDate.setMonth(nowDate.getMonth()-1);
              }
            } else {
              if(nowDate.getMonth()==0){
                nowDate.setMonth(10);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else if(nowDate.getMonth()==1){
                nowDate.setMonth(11);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else{
                nowDate.setMonth(nowDate.getMonth()-2);
              }
            }
            if(time.getFullYear()<2020){
              nowDate.setFullYear(time.getFullYear()-1)
              // console.dir(nowDate)
            }return time > nowDate
          }
        },

      }
    },
    created () {
      this.$emit('public_header', true)
      this.oneMonth()
      this.getAll()

    },
    mounted () {

    },
    methods: {
      getAll () {
        this.getHomeList()
        this.getGanPinTop()
      },
      //赣品首页
      getHomeList () {
        this.$http.get(this.header + '/featured/zt', {
          params: {
            times: this.endTime,
          }
        }).then(res => {
          if (res.data.code == 0) {
            if (res.data.total) {
              this.total = res.data.total
            } else {
              this.total = {}
            }

            //12个月网络零售额走势
            let moneyList = {xTime: [], yTotalMoney: [], simple: []}
            res.data.salesList.reverse().forEach((y, index) => {
              moneyList.xTime.push(y.times)
              let yMoney = {
                value: y.absoulte_value,
                unit: '万元'
              }
              let xSimple = {
                value: y.absoulte_value_yoy,
                unit: '%'
              }
              moneyList.yTotalMoney.push(yMoney)
              moneyList.simple.push(xSimple)
            })
            let MoneyMin1 = this.moneyCalMin(moneyList.yTotalMoney), MoneyMin2 = this.moneyCalMin(moneyList.simple),
              MoneyMax1 = this.moneyCalMax(moneyList.yTotalMoney), MoneyMax2 = this.moneyCalMax(moneyList.simple)
            //近13个月网络零售额走势图表
            this.moneyOptions = {
              color: ['#7888ed', '#FB975B'],
              title: {//图表标题
                text: '九江市特色赣品近13个月网零趋势图',
                left: 'left',
                textStyle: {
                  color: '#313131',
                  fontSize: 18,
                  fontWeight: 300,
                  marginBottom: 10000
                },
              },
              tooltip: { // 鼠标悬浮
                backgroundColor: 'rgba(50,50,50,0.7)',
                trigger: 'item',
                formatter: function (e) {
                  return e.name + e.seriesName + '<br/>' + e.value + e.data.unit
                }
              },
              toolbox: { //图表工具箱
                feature: {
                  // dataView: {show: true, readOnly: false},
                  magicType: {show: true, type: ['line']},
                  restore: {show: true},
                  saveAsImage: {show: true}
                }
              },
              legend: {//图表说明  horizontal竖着显示vertical横显示
                orient: 'horizontal',
                y: 'bottom',
                // x: 'left',
                textStyle: {
                  color: '#666',
                  fontSize: 14
                },
                data: ['当期网络零售额', '同比']
              },
              xAxis: {
                type: 'category',
                data: moneyList.xTime,
                axisLine: {
                  lineStyle: {
                    color: '#666'
                  }
                }
              },
              yAxis: [
                {
                  type: 'value',
                  name: '万元',
                  axisLine: {
                    lineStyle: {
                      color: '#666'
                    }
                  },
                  min: MoneyMin1,
                  max: MoneyMax1,
                  splitNumber: 5,
                  interval: (MoneyMax1 - MoneyMin1) / 5
                }, {
                  type: 'value',
                  name: '%',
                  axisLine: {
                    lineStyle: {
                      color: '#666'
                    }
                  },
                  min: MoneyMin2,
                  max: MoneyMax2,
                  splitNumber: 5,
                  interval: (MoneyMax2 - MoneyMin2) / 5,
                  axisLabel: {
                    formatter: '{value} %'
                  }
                }],
              series: [{
                name: '当期网络零售额',
                type: 'bar',
                barCategoryGap: '60%',
                itemStyle: {

                  emphasis: {
                    color: '#83bff6'
                  }
                },
                data: moneyList.yTotalMoney,
                smooth: true
              }, {
                name: '同比',
                type: 'line',
                yAxisIndex: 1,
                data: moneyList.simple
              }]
            }

            //赣品排行
            let wholeList = {xName: [], yTotalMoney: []}
            res.data.category.forEach((y, index) => {
              wholeList.xName.push(y.category)
              let yMoney = {
                value: y.ljMoney,
                unit: '元'
              }
              wholeList.yTotalMoney.push(yMoney)
            })
            this.categoryOptions = {
              title: {//图表标题
                text: '特色赣品累计网零排行',
                left: 'left',
                textStyle: {
                  color: '#313131',
                  fontSize: 18,
                  fontWeight: 300,
                  marginBottom: 1000
                },
              },
              grid: {
                left: '3%',
                // right: '4%',
                bottom: '3%',
                containLabel: true
              },
              tooltip: { // 鼠标悬浮
                backgroundColor: 'rgba(50,50,50,0.7)',
                trigger: 'item',
                formatter: '{b}网络零售额<br/>{c} 元'
              },
              toolbox: { //图表工具箱
                feature: {
                  // dataView: {show: true, readOnly: false},
                  magicType: {show: true, type: ['line', 'bar']},
                  // restore: {show: true},
                  saveAsImage: {show: true}
                }
              },
              xAxis: {
                type: 'value',
                name: '元',
                axisLine: {
                  lineStyle: {
                    color: '#666'
                  }
                },
              },
              yAxis: {
                type: 'category',
                // axisLabel: {'interval': 0, rotate: 40},
                axisLine: {
                  lineStyle: {
                    color: '#666'
                  }
                },
                data: wholeList.xName
              },
              // dataZoom: [{
              //   type: 'slider',//图表下方的伸缩条
              //   yAxisIndex: [0],
              //   left: 'left',
              //   show: true, //是否显示
              //   realtime: true, //拖动时，是否实时更新系列的视图
              //   start: 50, //伸缩条开始位置（1-100），可以随时更改
              //   end: 100, //伸缩条结束位置（1-100），可以随时更改
              // }],
              series: [{
                name: '月份',
                type: 'bar',
                barCategoryGap: '60%',
                itemStyle: {
                  normal: {
                    color: function (params) {
                      let colorList = ['#0ACDE5', '#4A82F4', '#F7AE4E', '#FC4B6C', '#8A98E8', '#F9B27E']
                      //  var colorList = ['red','blue'];
                      return colorList[params.dataIndex % 6]
                    }
                  },
                  emphasis: {
                    color: '#83bff6'
                  }
                },
                data: wholeList.yTotalMoney,
              }]
            }
            //地图
            this.mapList = res.data.provinceList
            let mapData = []
            res.data.provinceList.forEach((x, index) => {
              let cityNum = {
                name: x.province,
                value: x.money

              }
              mapData.push(cityNum)
            })
            //地图
            this.orgOptions = {
              title: {//图表标题
                text: '网络零售全景',
                left: 'left',
                textStyle: {
                  color: '#313131',
                  fontSize: 18,
                  fontWeight: 300,
                  marginBottom: 10000
                },
              },
              tooltip: { // 鼠标悬浮
                backgroundColor: 'rgba(50,50,50,0.7)',
                trigger: 'item',
                formatter: '{a}在{b}销售{c}元'
                //   function (e) {
                //   console.log(e)
                //   return e.name + '网络零售额' + e.value
                // }
              },
              visualMap: {
                min: 0,
                max: 10000,
                realtime: false,
                calculable: false,
                inRange: {
                  color: ['rgba(218,228,258,1)', 'rgba(143,176,245,1)', 'rgba(68,124,238,1)']
                }
              },
              series: [
                {
                  name: '九江特色产品',
                  type: 'map',
                  mapType: 'ZG', // 自定义扩展图表类型
                  itemStyle: {
                    normal: {label: {show: false, fontSize: 12}},
                    emphasis: {label: {show: false}, areaColor: 'beige'}
                  },
                  label: {
                    show: false
                  },
                  data: mapData
                }
              ]
            }
            //平台占比
            let platformList = {xLegend: [], yCom: []}
            res.data.platform.forEach((y, index) => {
              platformList.xLegend.push(y.paltform)
              let yMoney = {
                value: y.sales,
                name: y.paltform
              }
              platformList.yCom.push(yMoney)
            })
            //平台占比
            this.platformOptions = {
              title: {
                text: '电商平台累计占比',
                x: 'left',
                textStyle: {
                  color: '#313131',
                  fontSize: 18,
                  fontWeight: 300,
                  // bottom: 10,
                },
              },
              tooltip: {
                trigger: 'item',
                formatter: '{b}占比 : {d}%'
              },
              legend: {
                x: 'center',
                y: 'bottom',
                textStyle: {
                  color: '#666',
                  fontSize: 14
                },
                data: platformList.xLegend
              },
              calculable: true,
              series: [
                {
                  name: '半径模式',
                  type: 'pie',
                  radius: ['45%', '60%'],
                  center: ['50%', '40%'],
                  label: {
                    normal: {
                      show: false,
                      position: 'center'
                    },
                    emphasis: {
                      show: true,
                      textStyle: {
                        fontSize: '30',
                        fontWeight: 'bold',
                      }
                      // formatter: "{a} <br/>{b}: {c} ({d}%)"
                    }
                  },
                  lableLine: {
                    normal: {
                      show: false
                    },
                    emphasis: {
                      show: true
                    }
                  },
                  itemStyle: {
                    normal: {
                      color: function (params) {
                        let colorList = ['#71CBC0', '#85B0FB', '#F7AE4E', '#FFC4C6', '#4C8DFF', '#FF9F7F', '#FFDB5C', '#67E0E3', '#9FE6B8', '#32C5E9']
                        //  var colorList = ['red','blue'];
                        return colorList[params.dataIndex % 10]
                      }
                    },

                  },
                  data: platformList.yCom
                }
              ]
            }
          } else {
            this.$alert(res.data.msg)
          }

        })
      },
      //获取top信息
      getGanPinTop () {
        this.$http.get(this.header + '/featured/ztRank', {
          params: {
            times: this.endTime,
          }
        }).then(res => {
          if (res.data.code == 0) {
            this.goodsShopTable = res.data.shop
            this.companyTable = res.data.company
            this.goodsListTable = res.data.goods
          } else {
            this.$alert(res.data.msg)
          }
        })
      },
      // //地市排名计算最大值
      // cityCalMax (arr) {
      //   let max = 0
      //   // arr.forEach((el) => {
      //   arr.forEach((el1) => {
      //     if (!(el1 === undefined || el1 === '')) {
      //       if (max < el1) {
      //         max = el1
      //       }
      //     }
      //     // })
      //   })
      //   let maxint = Math.ceil(max / 9.5)//不让最高的值超过最上面的刻度
      //   let maxval = maxint * 10//让显示的刻度是整数
      //   return maxval
      // },
      //当月网络零售额走势图表计算最大值
      moneyCalMax (arr) {
        let max = 0
        // arr.forEach((el) => {
        arr.forEach((el1) => {
          if (!(el1 === undefined || el1 === '')) {
            if (max < el1.value) {
              max = el1.value
            }
          }
          // })
        })
        let maxInt = Math.ceil(max / 9.5)//不让最高的值超过最上面的刻度
        let maxVal = maxInt * 10//让显示的刻度是整数
        return maxVal
      },

      //当月网络零售额走势图表计算最小值
      moneyCalMin (arr) {
        let min = 0
        // arr.forEach((el) => {
        arr.forEach((el1) => {
          if (!(el1 === undefined || el1 === '')) {
            if (min > el1.value) {
              min = el1.value
            }
          }
        })
        // })
        let minInt = Math.floor(min / 10)
        let minVal = minInt * 10//让显示的刻度是整数
        return minVal
      },
      //选择近1个月
      oneMonth (val) {
        let dataArr = []
        let data = new Date()
        let day = data.getDate()
        data.setMonth(data.getMonth() + 1, 1)//获取到当前月份,设置月份
        for (let i = 0; i < 3; i++) {
          data.setMonth(data.getMonth() - 1)//每次循环一次 月份值减1
          let m = data.getMonth() + 1
          m = m < 10 ? '0' + m : m
          dataArr.push(data.getFullYear() + '-' + (m))
        }
        if (day > 14) {
          this.endTime = dataArr[1]
        } else {
          this.endTime = dataArr[2]
        }
        // console.dir(dataArr)
      }
    }
  }

</script>

<style>

  .ganPin .ganPin-index-data .el-col {
    height: 100px;
    margin-right: 30px;
    background-color: #2A3039;
    width: 380px;
    padding: 20px;
    color: #A9B5C7;
    margin-bottom: 30px;
  }

  .ganPin .ganPin-header {
    text-align: left;
    margin-bottom: 8px;
    height: 45px;
    line-height: 45px;
    background: white;
    border: 1px solid rgba(100, 156, 238, 0.4);
    box-shadow: 0px 6px 7px 4px rgba(0, 0, 0, 0.04);
    border-radius: 4px;
    color: #6589C5;
  }

  .ganPin .ganPin-header .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 120px;
  }

  .ganPin .ganPin-header .el-date-editor input {
    background: white !important;
    width: 115px;
    height: 27px;
    line-height: 27px;
    border: 1px solid rgba(100, 156, 238, 0.4);
  }

  .ganPin .ganPin-header .areaChoose input {
    background: rgba(36, 46, 71, 0.3) !important;
    border: 1px solid rgba(255, 255, 255, 0.3);
    /*width: 115px;*/
    height: 27px;
    line-height: 27px;
  }

  .ganPin .area-total p {
    color: #333333;
    font-size: 16px;
    font-weight: bold;
  }

  .ganPin-num {
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #6589C5;
  }

  .ganPin .el-col-6 {
    /*border-left: 1px solid;*/
    border-image: linear-gradient(to bottom, #fff, #A8A8A8) 0.4 1;
    /*padding-left: 1%;*/
  }

  .ganPin-index .ganPin-index-data {
    overflow: hidden;
  }

  .ganPin-index .data-one {
    border: 2px solid #EC846B;
    border-radius: 4px;
    width: 62px;
    height: 62px;
    padding: 16px;
    color: #EC846B;
    font-size: 28px;
  }

  .ganPin .area-index-num {
    font-size: 26px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    margin-top: 20px;
  }
  .ganPin .index-span-p{
    color: white;
    margin-top: 10px;
  }
  .ganPin .index-span-box {
    width: 100%;
    margin-right: 40px;
    /*width: 100%;*/
    /*margin-top: -45px !important;*/
    background-size: 100% 100%;
    height: 55px;
  }
  .ganPin-index .data-two {
    border: 2px solid #E3B367;
    border-radius: 4px;
    width: 62px;
    height: 62px;
    padding: 16px;
    color: #E3B367;
    font-size: 28px;
  }

  .ganPin-index .data-three {
    border: 2px solid #ABC471;
    border-radius: 4px;
    width: 62px;
    height: 62px;
    padding: 16px;
    color: #ABC471;
    font-size: 28px;
  }
  .ganPin .index-bg{
    background-size: 100% 100%;
    border-radius: 10px 10px 10px 10px;
    height: 110px;
    padding-top: 5px;
    width: 100%;
  }

  .ganPin-index .data-four {
    border: 2px solid #60BDDF;
    border-radius: 4px;
    width: 62px;
    height: 62px;
    padding: 16px;
    color: #60BDDF;
    font-size: 28px;
  }

  .index .topicOne {
    /*background: linear-gradient(225deg, rgba(255, 73, 65, 1), rgba(225, 7, 7, 1));*/
    background-color: #4270F2;
    border-radius: 50%;
    height: 25px;
    line-height: 25px;
    width: 25px;
    color: white;
    margin-top: 8px;
  }

  .index .topicTwo {
    background: cornflowerblue;
    border-radius: 50%;
    height: 25px;
    line-height: 25px;
    width: 25px;
    color: white;
    margin-top: 8px;
  }

  .index .topicThree {
    background: rgba(143, 176, 245, 1);
    border-radius: 50%;
    height: 25px;
    width: 25px;
    line-height: 25px;
    color: white;
    margin-top: 8px;
  }

  .index .topicOther {
    /*background: linear-gradient(225deg, rgba(255, 165, 81, 1), rgba(255, 135, 16, 1));*/
    background-color: #8A8A8A;
    border-radius: 50%;
    height: 25px;
    width: 25px;
    line-height: 25px;
    color: white;
    margin-top: 8px;
  }

</style>



// WEBPACK FOOTER //
// src/components/ganPinMonitoring/ganpin-index.vue